const o = "tooltip", t = "tooltip__icon", i = {
  tooltip: o,
  tooltip__icon: t,
  "tooltip__icon--active": "tooltip__icon--active"
};
export {
  i as default,
  o as tooltip,
  t as tooltip__icon
};
